import { render } from "./PaginationProducts.vue?vue&type=template&id=7a56a770"
import script from "./PaginationProducts.vue?vue&type=script&lang=js"
export * from "./PaginationProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__